import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { adminLogout, getAdminUser } from '../../../utils/admin/logout';

const Header = ({ onMenuToggle }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const dropdownRef = useRef(null);
  const user = getAdminUser();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuItemClick = () => {
    setShowUserMenu(false);
  };

  const handleUserMenuToggle = () => {
    setShowUserMenu(!showUserMenu);
  };

  const handleLogout = () => {
    adminLogout({
      showConfirmation: false,
      showToast: false
    });
  };

  if (!user) return null;

  return (
    <header className="navbar bg-white shadow-sm z-10 sticky top-0">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center">
          <button 
            onClick={onMenuToggle}
            className="md:hidden text-gray-400 focus:outline-none mr-2"
          >
            <i className="fas fa-bars text-xl"></i>
          </button>

          <div className="flex items-center md:hidden">
            <img 
                src="/logo-light.png" 
                alt="Hunar Pool" 
                className="h-8 w-auto mx-auto" 
                draggable="false"
            />
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <div className="relative">
            <button className="text-white hover:text-gray-200 relative">
              <i className="fas fa-bell text-xl"></i>
              <span className="absolute -top-1 -right-1 inline-block w-3 h-3 bg-red-500 rounded-full"></span>
            </button>
          </div>
          
          {/* User Menu */}
          <div className="relative" ref={dropdownRef}>
            <button 
              onClick={handleUserMenuToggle}
              className="flex items-center text-sm focus:outline-none"
            >
              <div className="h-8 w-8 rounded-full bg-gradient-to-r from-[#0096C7] to-[#4361EE] hover:from-[#00a8e0] hover:to-[#4a6bf5] flex items-center justify-center text-white font-semibold">
                {user.user?.firstName?.charAt(0) || 'A'}
              </div>
              <span className="ml-2 text-gray-100 font-medium hidden md:block">Hi {user.user?.firstName} {user.user?.lastName}</span>
              <i className="fas fa-chevron-down ml-1 text-gray-100 text-xs"></i>
            </button>
            
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
                <Link 
                  to="/hpanel/profile" 
                  onClick={handleMenuItemClick}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <i className="fas fa-user mr-2"></i>My Profile
                </Link>
                <Link 
                  to="/hpanel/settings" 
                  onClick={handleMenuItemClick}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <i className="fas fa-cog mr-2"></i>Settings
                </Link>
                <Link 
                  to="/hpanel/change-password" 
                  onClick={handleMenuItemClick}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <i className="fas fa-lock mr-2"></i>Change Password
                </Link>
                <div className="border-t border-gray-100"></div>
                <button 
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                >
                  <i className="fas fa-sign-out-alt mr-2"></i>Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;